
/**
* пример вывода (для UTC+3): 2026-04-11T15:30:00.000+03:00
* **/
export const getLocalDateISO = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset(); // Смещение в минутах
    const offsetAbs = Math.abs(offset);
    const isoString = new Date(now.getTime() - (offset * 60000)).toISOString();

    // Формат: YYYY-MM-DDTHH:mm:ss.sss+HH:mm или -HH:mm
    return isoString.slice(0, -1) +
           (offset > 0 ? '-' : '+') +
           String(Math.floor(offsetAbs / 60)).padStart(2, '0') + ':' +
           String(offsetAbs % 60).padStart(2, '0');
};